module.exports = __webpack_public_path__ + "img/fruit-quince-350x184.05859554.jpg";